import styled from 'styled-components'
import { OtherText } from 'styling/Typography'

export const ChartRoot = styled.div<{ $height: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${(p) => p.$height};
  gap: 0.5rem;
`

export const BarsRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex: 1;
  width: 100%;
  gap: 2px;
  min-height: 0;
`

export const BarSlot = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  height: 100%;
  min-width: 0;
`

export const Bar = styled.div<{ $heightPercent: number }>`
  width: 100%;
  height: ${(p) => p.$heightPercent}%;
  background: ${(p) => p.theme.colorOrange};
  border-radius: 0;
`

export const AxisRow = styled.div`
  display: flex;
  width: 100%;
  gap: 2px;
`

export const AxisSlot = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  min-width: 0;
`

export const AxisLabel = styled(OtherText)`
  color: ${(p) => p.theme.greyText};
  font-size: 0.625rem;
  line-height: 1rem;
  white-space: nowrap;
`
